import React from "react";
import CommentsForm from "components/comments/CommentsForm";
import { PhotoCheers, StoryCheer } from "components/common/Cheers";
import { Icon } from "@culturehq/components";

const CommentsWrapper = ({
  commentCount,
  createCall,
  onChange,
  onCommentClick,
  onCreateComment,
  onCheerToggle,
  onToggleCommentCheer,
  options,
  profile,
  showAvatar = true,
  story = null,
  photo = null,
  showButton = true,
  children
}) => (
  <div className="gallery-lightbox__comments">
    <div className="comments-form row">
      <div className="col-xs-12">
        <hr />
      </div>
      <div className="row">
        <div className="col-xs-12 comments-form--data">
          <div className="col-xs-6">
            {story && <StoryCheer story={story} onCheerToggle={onCheerToggle} />}
            {photo && <PhotoCheers photo={photo} onCheerToggle={onCheerToggle} />}
          </div>
          <div className="col-xs-6 comments-form--data-message">
            {showButton && (
              <div
                className="btn gallery-lightbox__comment-button clickable"
                onClick={onCommentClick}
              >
                <Icon icon="ios-chatbubble-outline" />{" "}
                Comment{commentCount > 0 && `s (${commentCount})`}
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
      <div className="col-xs-12">
        <CommentsForm
          createCall={createCall}
          showAvatar={showAvatar}
          onChange={onChange}
          options={options}
          onCreateComment={onCreateComment}
          onToggleCommentCheer={onToggleCommentCheer}
          profile={profile}
        />
      </div>
    </div>
  </div>
);

export default CommentsWrapper;
